<template>
  <div class="large_main">
    <div class="top_title">
      <div class="title_text">梯联网大数据看板</div>
      <div class="time">{{ time }}</div>
    </div>
    <div class="large_content">
      <div class="page_main">
        <div class="left">
          <div class="anay_device_box item_box">
            <div class="item_title_box">设备统计</div>
            <div class="anay_device_content">
              <div class="device_label">
                <div class="label_list">
                  <img class="icon" src="@/assets/other/a1.png" />
                  小区数量：<span>{{ formData.communityNumber }}个</span>
                </div>
                <div class="label_list">
                  <img class="icon" src="@/assets/other/a2.png" />
                  我的设备：<span
                    >{{
                      formData.onlineNumber +
                      formData.offlineNumber +
                      formData.faultNumber
                    }}个</span
                  >
                </div>
              </div>
              <div class="device_charts">
                <div class="today_charts" id="warnToday"></div>
                <div class="today_legend">
                  <div class="legend_list">
                    <img class="icon" src="@/assets/image/l1.png" alt="" />
                    <img class="line" src="@/assets/image/line1.png" alt="" />
                    <div class="value_box">
                      <div class="status">
                        <img class="arrow" src="@/assets/image/ar1.png" alt="" />
                        在线设备
                      </div>
                      <div class="value">{{ formData.onlineNumber }}</div>
                    </div>
                  </div>
                  <div class="legend_list">
                    <img class="icon" src="@/assets/image/l2.png" alt="" />
                    <img class="line" src="@/assets/image/line2.png" alt="" />
                    <div class="value_box">
                      <div class="status warn">
                        <img class="arrow" src="@/assets/image/ar2.png" alt="" />
                        离线设备
                      </div>
                      <div class="value">{{ formData.offlineNumber }}</div>
                    </div>
                  </div>
                  <div class="legend_list">
                    <img class="icon" src="@/assets/image/l3.png" alt="" />
                    <img class="line" src="@/assets/image/line3.png" alt="" />
                    <div class="value_box">
                      <div class="status danger">
                        <img class="arrow" src="@/assets/image/ar3.png" alt="" />
                        故障设备
                      </div>
                      <div class="value">{{ formData.faultNumber }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ele_year_anay item_box">
            <div class="item_title_box">电梯年限统计</div>
            <div class="year_content" id="malfunction"></div>
          </div>
          <div class="warn_anay_box item_box">
            <div class="item_title_box">报警统计</div>
            <div class="warn_anay_content">
              <div class="label_list">
                <img class="icon" src="@/assets/other/a3.png" />
                告警事件总数：<span>14起</span>
              </div>
              <div class="warn_list_box">
                <div class="swiper-wrapper">
                  <div
                    class="warn_list swiper-slide"
                    v-for="(item, index) in 15"
                    :key="index"
                  >
                    <div class="warn_left">
                      <div class="icon"></div>
                      <div class="text">报警触发装置动作</div>
                    </div>
                    <div class="line"></div>
                    <div class="warn_right">
                      <div class="process">
                        <div class="process_line" :style="'width:' + 30 + '%'"></div>
                      </div>
                      7
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="center">
          <div class="map_box">
            <div
              class="back"
              v-if="currentLevel === 'city'"
              @click="backToProvince"
            ></div>
            <div class="map_content" id="map"></div>
          </div>
          <div class="center_info">
            <div class="trap_box item_box">
              <div class="item_title_box duan">困人数据</div>
              <div class="trap_content">
                <div class="trap_list">
                  <img class="icon" src="@/assets/other/tag.png" />
                  <div class="text">当前困人事件：{{ formData.trappedNumber }}起</div>
                </div>
                <div class="trap_list">
                  <img class="icon" src="@/assets/other/tag.png" />
                  <div class="text">平均困人时长：{{ formData.trappedTime }}分钟</div>
                </div>
                <div class="trap_list">
                  <img class="icon" src="@/assets/other/tag.png" />
                  <div class="text">救援到场时间：{{ formData.arrivalTime }}分钟</div>
                </div>
              </div>
            </div>
            <div class="ele_trap_box item_box">
              <div class="item_title_box chang">电梯困人信息</div>
              <div class="ele_trap_content">
                <el-table
                  :data="tableList"
                  class="tableSpec"
                  style="height: 100%"
                  max-height="258"
                >
                  <el-table-column
                    min-width="100"
                    align="center"
                    label="告警时间"
                    prop="beginTime"
                  />
                  <el-table-column
                    min-width="100"
                    align="center"
                    label="电梯名称"
                    prop="elevatorName"
                  />
                  <el-table-column
                    min-width="100"
                    align="center"
                    label="所属小区"
                    prop="communityName"
                  />
                  <el-table-column
                    min-width="100"
                    align="center"
                    label="困人时长"
                    prop="trappedDate"
                  />
                  <el-table-column min-width="100" align="center" label="状态">
                    <template slot-scope="scope">
                      {{ scope.row.status == 1 ? "已处理" : "未处理" }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    min-width="100"
                    align="center"
                    label="维保工作"
                    prop="wbUserName"
                  />
                  <el-table-column
                    min-width="100"
                    align="center"
                    label="处理人电话"
                    prop="wbPhone"
                  />
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="wb_anay_box item_box">
            <div class="item_title_box">设备统计</div>
            <div class="wb_anay_content">
              <div class="device_label">
                <div class="label_list">
                  <img class="icon" src="@/assets/other/a4.png" />
                  今日计划：<span>0起</span>
                </div>
                <div class="label_list">
                  <img class="icon" src="@/assets/other/a5.png" />
                  已完成：<span>0起</span>
                </div>
              </div>
              <div class="wb_charts" id="wb_charts"></div>
            </div>
          </div>
          <div class="wb_anay_box item_box">
            <div class="item_title_box">维修统计</div>
            <div class="wb_anay_content">
              <div class="device_label">
                <div class="label_list">
                  <img class="icon" src="@/assets/other/a4.png" />
                  今日计划：<span>0起</span>
                </div>
                <div class="label_list">
                  <img class="icon" src="@/assets/other/a5.png" />
                  已完成：<span>0起</span>
                </div>
              </div>
              <div class="wb_charts" id="repair_charts"></div>
            </div>
          </div>
          <div class="save_anay_box item_box">
            <div class="item_title_box">救援统计</div>
            <div class="save_content">
              <div class="label_list">
                <img class="icon" src="@/assets/other/a6.png" />
                今日计划：<span>0起</span>
              </div>
              <div class="save_charts" id="saveCharts"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="large_bottom"></div>
  </div>
</template>

<script>
import { getBoardData, getMapData } from "@/api/user";
import { areaNameMap, mapDataToEcharts } from "@/utils";
import Swiper from "swiper"; // 注意引入的是Swiper
import * as echarts from "echarts";

import hubeiGeoJson from "@/utils/map.json"; // 湖北省geojson
// 市区geojson示例引入写法（实际建议动态import或按需加载）
import shiyan from "@/utils/cities/shiyan.json";
import shennongjia from "@/utils/cities/shennongjia.json";
import enshi from "@/utils/cities/enshi.json";
import xiangyang from "@/utils/cities/xiangyang.json";
import yichang from "@/utils/cities/yichang.json";
import suizhou from "@/utils/cities/suizhou.json";
import jingmen from "@/utils/cities/jingmen.json";
import jingzhou from "@/utils/cities/jingzhou.json";
import xiaogan from "@/utils/cities/xiaogan.json";
import tianmen from "@/utils/cities/tianmen.json";
import qianjiang from "@/utils/cities/qianjiang.json";
import xiantao from "@/utils/cities/xiantao.json";
import wuhan from "@/utils/cities/wuhan.json";
import huanggang from "@/utils/cities/huanggang.json";
import ezhou from "@/utils/cities/ezhou.json";
import huangshi from "@/utils/cities/huangshi.json";
import xianning from "@/utils/cities/xianning.json";
export default {
  name: "ElevatorLargeIndex",
  components: {},
  data() {
    return {
      url:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimage109.360doc.com%2FDownloadImg%2F2025%2F04%2F0321%2F296122601_4_20250403090445718&refer=http%3A%2F%2Fimage109.360doc.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1754030365&t=23cde2530243c9a9130347d2132acb9c",
      time: "",
      tableList: [],
      currentLevel: "province", // 省级或市级
      currentMapName: "hubei", // 当前注册的地图名称
      formData: {},
      deviceAnay: [],
      repairList: [],
      rescueList: [],
      resizeHandler: null,
    };
  },

  mounted() {
    this.getTime();
    this.initWarnToday();
    this.swiperInitWarn();
    this.initMap();
    this.getData();

    // 响应式：窗口变化时重绘 echarts
    this.resizeHandler = () => this.resizeCharts();
    window.addEventListener("resize", this.resizeHandler);
    // 响应式布局下 echarts init 时容器可能尚未 layout 完毕，
    // 延迟 300ms 强制首次 resize，防地图渲染成 0×0
    setTimeout(() => this.resizeCharts(), 300);
  },
  beforeDestroy() {
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
      this.resizeHandler = null;
    }
  },

  methods: {
    resizeCharts() {
      ["map", "warnToday", "malfunction", "wb_charts", "repair_charts", "saveCharts"].forEach(
        (id) => {
          const element = document.getElementById(id);
          const chart = element && echarts.getInstanceByDom(element);
          if (chart && !chart.isDisposed()) {
            chart.resize();
          }
        }
      );
    },
    getData() {
      getBoardData().then((res) => {
        this.formData = res.data;
        this.deviceAnay = res.data.deviceListVos;
        this.repairList = res.data.upkeepListVos;
        this.rescueList = res.data.rescueListVos;
        this.tableList = res.data.trappedListVos;
        this.$nextTick(() => {
          this.initMalfunction();
          this.initWbAnay();
          this.initRepair();
          this.initSave();
        });
      });
    },
    initMap(mapName = "hubei", geoJson = hubeiGeoJson, mapTitle = "湖北省") {
      const myChart = echarts.init(document.getElementById("map"));
      this.myChart = myChart;
      echarts.registerMap(mapName, geoJson);
      if (this.currentLevel == "province") {
        getMapData({
          areaId: "42",
        }).then((res) => {
          const cityData = mapDataToEcharts(res.data);
          const option = {
            title: {
              text: mapTitle,
              left: "center",
              textStyle: {
                color: "#fff",
                fontSize: 18,
                fontWeight: "bold",
              },
            },
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                if (params.value) return `${params.name}: ${params.value}`;
                return params.name;
              },
            },
            series: [
              {
                name: mapTitle,
                type: "map",
                map: mapName,
                roam: false,
                zoom: 1.15,
                label: { show: true },
                itemStyle: {
                  areaColor: "#8FB8D6",
                  borderColor: "#404a59",
                },
                emphasis: {
                  label: { show: true, color: "#fff", fontWeight: "bold" },
                  itemStyle: { areaColor: "#f0a31a" },
                },
                data: cityData,
              },
            ],
          };
          myChart.setOption(option);
          // 点击事件，切换市区地图
          myChart.off("click");
          myChart.on("click", (params) => {
            if (this.currentLevel === "province") {
              const cityName = params.name;
              this.loadCityMap(cityName);
            }
          });
        });
      } else {
        getMapData({
          areaId: areaNameMap[mapTitle] || mapTitle,
        }).then((res) => {
          const cityData = mapDataToEcharts(res.data, geoJson);
          const option = {
            title: {
              text: mapTitle,
              left: "center",
              textStyle: {
                color: "#fff",
                fontSize: 18,
                fontWeight: "bold",
              },
            },
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                if (params.value) return `${params.name}: ${params.value}`;
                return params.name;
              },
            },
            series: [
              {
                name: mapTitle,
                type: "map",
                map: mapName,
                roam: false,
                zoom: 1.15,
                label: { show: true },
                itemStyle: {
                  areaColor: "#8FB8D6",
                  borderColor: "#404a59",
                },
                emphasis: {
                  label: { show: true, color: "#fff", fontWeight: "bold" },
                  itemStyle: { areaColor: "#f0a31a" },
                },
                data: cityData,
              },
            ],
          };
          myChart.setOption(option);
        });
      }
    },
    loadCityMap(cityName) {
      console.log(cityName, "cityNamecityNamecityName");
      // 市名转拼音映射（示例，建议完善）
      const cityMap = {
        十堰市: { mapName: "shiyan", geoJson: shiyan },
        神农架林区: { mapName: "shennongjia", geoJson: shennongjia },
        恩施土家族苗族自治州: { mapName: "enshi", geoJson: enshi },
        襄阳市: { mapName: "xiangyang", geoJson: xiangyang },
        宜昌市: { mapName: "yichang", geoJson: yichang },
        随州市: { mapName: "suizhou", geoJson: suizhou },
        荆门市: { mapName: "jingmen", geoJson: jingmen },
        荆州市: { mapName: "jingzhou", geoJson: jingzhou },
        孝感市: { mapName: "xiaogan", geoJson: xiaogan },
        天门市: { mapName: "tianmen", geoJson: tianmen },
        潜江市: { mapName: "qianjiang", geoJson: qianjiang },
        仙桃市: { mapName: "xiantao", geoJson: xiantao },
        武汉市: { mapName: "wuhan", geoJson: wuhan },
        黄冈市: { mapName: "huanggang", geoJson: huanggang },
        鄂州市: { mapName: "ezhou", geoJson: ezhou },
        黄石市: { mapName: "huangshi", geoJson: huangshi },
        咸宁市: { mapName: "xianning", geoJson: xianning },
        // 其他市对应json要补充
      };
      const city = cityMap[cityName];
      if (!city) {
        alert("未找到该市的地图数据！");
        return;
      }
      this.currentLevel = "city";
      this.currentMapName = city.mapName;
      this.myChart.dispose(); // 销毁原图实例
      this.initMap(city.mapName, city.geoJson, cityName); // 传入市区地图参数
    },
    backToProvince() {
      if (this.currentLevel === "city") {
        this.currentLevel = "province";
        this.currentMapName = "hubei";
        this.myChart.dispose();
        this.initMap("hubei", hubeiGeoJson, "湖北省");
      }
    },
    initSave() {
      const charts = echarts.init(document.getElementById("saveCharts"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["维修数"],
          textStyle: {
            color: "#fff",
          },
          top: 5,
          left: 10,
        },
        grid: {
          left: "3%",
          right: "4%",
          top: 40,
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.rescueList.map((item) => {
            return item.dateDay;
          }),
          axisLine: {
            lineStyle: {
              color: "#3c88a3",
            },
          },
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "#2a6f8f",
              type: "dashed",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#3c88a3",
            },
          },
          axisLabel: {
            color: "#fff",
          },
        },
        series: [
          {
            name: "维修数",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            itemStyle: {
              color: "#00F7FF",
              borderColor: "#001f2d",
              borderWidth: 2,
            },
            lineStyle: {
              color: "#00F7FF",
              width: 2,
            },
            data: this.rescueList.map((item) => {
              return item.rescueNumber;
            }),
          },
        ],
      };
      charts.setOption(option);
    },
    initRepair() {
      const charts = echarts.init(document.getElementById("repair_charts"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["提交维修数", "已维修"],
          textStyle: { color: "#fff" },
          top: 0,
        },
        grid: {
          left: "3%",
          top: "17%",
          right: "4%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.repairList.map((item) => {
            return item.dateDay;
          }),
          axisLine: { lineStyle: { color: "#3c88a3" } },
          axisLabel: { color: "#fff" },
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "#2a6f8f",
              type: "dashed",
            },
          },
          axisLine: { lineStyle: { color: "#3c88a3" } },
          axisLabel: { color: "#fff" },
        },
        series: [
          {
            name: "提交维修数",
            type: "bar",
            barWidth: 14,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(0, 191, 255, 1)" },
                { offset: 1, color: "rgba(0, 191, 255, 0.2)" },
              ]),
            },
            data: this.repairList.map((item) => {
              return item.upkeepNumber;
            }),
          },
          {
            name: "已维修",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            lineStyle: {
              color: "#FFC300",
              width: 2,
            },
            itemStyle: {
              color: "#FFC300",
              borderColor: "#001f2d",
              borderWidth: 2,
            },
            data: this.repairList.map((item) => {
              return item.doneNumber;
            }),
          },
        ],
      };
      charts.setOption(option);
    },
    initWbAnay() {
      const charts = echarts.init(document.getElementById("wb_charts"));
      const option = {
        backgroundColor: "transparent", // 外部可配纹理背景图
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "5%",
          top: "7%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.deviceAnay.map((item) => {
            return item.dateDay;
          }),
          axisLine: {
            lineStyle: {
              color: "#3c88a3",
            },
          },
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 1,
          splitLine: {
            lineStyle: {
              color: "#2a6f8f",
              type: "dashed",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#3c88a3",
            },
          },
          axisLabel: {
            color: "#fff",
          },
        },
        series: [
          {
            type: "bar",
            barWidth: 14,
            data: this.deviceAnay.map((item) => {
              return item.deviceNumber;
            }),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(0, 255, 255, 1)" },
                { offset: 1, color: "rgba(0, 255, 255, 0.2)" },
              ]),
            },
          },
        ],
      };
      charts.setOption(option);
    },
    swiperInitWarn() {
      new Swiper(".warn_list_box", {
        slidesPerView: "6",
        loop: true, // 循环模式选项
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },
    initMalfunction() {
      const data = [
        { name: "3年以下", value: this.formData.threeYearsNumber },
        { name: "3-6年", value: this.formData.twoYearsNumber },
        { name: "6-9年", value: this.formData.sixYearsNumber },
        { name: "9-12年", value: this.formData.nineYearsNumber },
        { name: "12-15年", value: this.formData.twelveYearsNumber },
        { name: "15年以上", value: this.formData.fifteenYearsNumber },
      ];
      const colors = ["#3385FF", "#00CCFF", "#00FFFF", "#FF9933", "#FF3333", "#FFD700"];
      const charts = echarts.init(document.getElementById("malfunction"));
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}：{c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          right: 10,
          top: 20,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
          formatter: (name) => {
            const item = data.find((d) => d.name === name);
            const percent = (
              (item.value / (data.reduce((sum, item) => sum + item.value, 0) || 1)) *
              100
            ).toFixed(2);
            return `${name}  ${item.value} (${percent}%)`;
          },
        },
        series: [
          {
            name: "告警类型",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            color: colors,
            data,
          },
        ],
      };
      charts.setOption(option);
    },
    initWarnToday() {
      const data = [
        { name: "重复开关门", value: 365 },
        { name: "非平层停梯", value: 365 },
        { name: "非平层开门", value: 365 },
        { name: "蹲底", value: 365 },
        { name: "困人（AI）", value: 365 },
        { name: "开门故障", value: 365 },
      ];
      const colors = ["#3385FF", "#00CCFF", "#00FFFF", "#FF9933", "#FF3333", "#FFD700"];
      const charts = echarts.init(document.getElementById("warnToday"));
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}：{c} ({d}%)",
        },
        series: [
          {
            name: "告警类型",
            type: "pie",
            radius: ["55%", "70%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            color: colors,
            data,
          },
        ],
      };
      charts.setOption(option);
    },

    getTime() {
      this.getCurrentDateTime();
      setInterval(() => {
        this.getCurrentDateTime();
      }, 1000);
    },

    getCurrentDateTime() {
      let now = new Date();
      // 获取日期部分
      let year = now.getFullYear();
      let month = (now.getMonth() + 1).toString().padStart(2, "0"); // 月份从0开始，所以要+1
      let day = now.getDate().toString().padStart(2, "0");
      // 获取时间部分
      let hours = now.getHours().toString().padStart(2, "0");
      let minutes = now.getMinutes().toString().padStart(2, "0");
      let seconds = now.getSeconds().toString().padStart(2, "0");
      // 获取星期部分
      let weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      let weekDay = weekDays[now.getDay()];
      // 组合成目标格式
      this.time = `${year}.${month}.${day} ${hours}:${minutes}:${seconds} ${weekDay}`;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/viewport.scss";

.large_main {
  position: relative;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background: #031321 url("@/assets/image/big_bg.png") center / cover no-repeat;
  padding: 0 vw(20);
  .top_title {
    background: url("@/assets/image/large_top_bg.png") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: vh(90);
    position: relative;
    .title_text {
      width: 100%;
      text-align: center;
      padding-top: vh(6);
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: vw(40);
      color: #fff;
      letter-spacing: vw(4);
    }
    .time {
      position: absolute;
      margin: auto;
      right: vw(60);
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 700;
      font-size: vw(18);
      color: #fff;
      bottom: vh(16);
    }
  }

  .large_content {
    height: calc(100% - vh(154));
    width: 100%;
    display: flex;
    justify-content: space-between;

    .page_main {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      .left {
        width: vw(440);
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .anay_device_box {
          width: 100%;
          height: calc((100% - vh(330)) / 2);
          .anay_device_content {
            background: url("@/assets/image/g1.png") no-repeat center;
            background-size: 100% 100%;
            width: calc(100% - vw(30));
            height: calc(100% - vh(72));
            padding: vh(15);

            .device_charts {
              height: calc(100% - vh(40));
              margin-top: vh(10);
              display: flex;
              justify-content: space-between;
              .today_charts {
                width: 50%;
                height: 100%;
              }
              .today_legend {
                width: 50%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: space-between;
                .legend_list {
                  height: vh(36);
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  width: 100%;
                  .icon {
                    width: vw(40);
                    height: vh(32);
                  }
                  .line {
                    height: vh(30);
                    width: 1px;
                    margin: auto vw(20);
                  }
                  .value_box {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: space-between;
                    .status {
                      display: flex;
                      align-items: center;
                      font-weight: 400;
                      font-size: vw(12);
                      color: #00cb61;
                      .arrow {
                        margin-right: vw(10);
                        width: vw(14);
                        height: vh(12);
                      }
                      &.warn {
                        color: #e2b400;
                      }
                      &.danger {
                        color: #d01c00;
                      }
                    }
                    .value {
                      width: vw(25);
                      height: vh(26);
                      font-family: D-DIN;
                      font-weight: 700;
                      font-size: vw(14);
                      color: #fff;
                      line-height: vh(14);
                    }
                  }
                }
              }
            }
          }
        }
        .ele_year_anay {
          width: 100%;
          height: calc((100% - vh(330)) / 2);
          .year_content {
            background: url("@/assets/image/g1.png") no-repeat center;
            background-size: 100% 100%;
            width: 100%;
            height: calc(100% - vh(42));
          }
        }
        .warn_anay_box {
          height: vh(302);
          width: 100%;
          .warn_anay_content {
            background: url("@/assets/other/baoxian_bg.png") no-repeat center;
            background-size: 100% 100%;
            width: calc(100% - vw(30));
            height: calc(100% - vh(72));
            padding: vh(15);
            .label_list {
              width: vw(180);
              height: vh(30);
              font-weight: 400;
              white-space: nowrap;
              font-size: vw(14);
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              background: url("@/assets/other/lab_bg.png") no-repeat center;
              background-size: 100% 100%;
              .icon {
                width: vw(22);
                height: vw(22);
                margin: 0 vw(10) 0 vw(20);
              }
            }
            .warn_list_box {
              height: calc(100% - vh(35));
              width: 100%;
              margin-top: vh(5);
              overflow: hidden;
              .warn_list {
                box-sizing: border-box;
                display: flex;
                align-items: center;
                .warn_left {
                  width: vw(180);
                  height: 100%;
                  display: flex;
                  align-items: center;
                  .icon {
                    width: vw(12);
                    height: vh(8);
                    background: linear-gradient(180deg, #23a9e3 0%, #b2e8ff 97%);
                    border-radius: 2px;
                    margin-right: vw(6);
                  }
                  .text {
                    flex: 1;
                    font-weight: 400;
                    font-size: vw(12);
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                  }
                }
                .line {
                  height: 100%;
                  width: 0;
                  border-left: 1px dashed #1e4f7b;
                }
                .warn_right {
                  flex: 1;
                  height: 100%;
                  font-weight: 700;
                  font-size: vw(12);
                  color: #fff;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  .process {
                    width: vw(180);
                    margin: auto vw(10);
                    height: vh(6);
                    background: rgba(49, 81, 121, 0.2);
                    .process_line {
                      height: vh(6);
                      background: linear-gradient(270deg, #23a9e3 0%, #b2e8ff 100%);
                    }
                  }
                }
              }
            }
          }
        }
      }
      .center {
        width: calc(100% - vw(900));
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .map_box {
          width: 100%;
          flex: 1;
          position: relative;
          .back {
            position: absolute;
            margin: auto;
            cursor: pointer;
            left: 0;
            top: 0;
            background: url("@/assets/image/back.png") no-repeat center;
            background-size: 100% 100%;
            width: vw(124);
            height: vh(36);
            z-index: 999;
          }
          .map_content {
            width: 100%;
            height: 100%;
          }
        }
        .center_info {
          width: 100%;
          height: vh(302);
          display: flex;
          justify-content: space-between;
          .trap_box {
            height: 100%;
            width: vw(340);
            .trap_content {
              height: vh(260);
              width: 100%;
              background: url("@/assets/other/baoxian_bg.png") no-repeat center;
              background-size: 100% 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-evenly;
              .trap_list {
                width: vw(320);
                height: vh(42);
                background: url("@/assets/other/trap_bg.png") no-repeat center;
                background-size: 100% 100%;
                display: flex;
                align-items: center;
                .icon {
                  width: vw(26);
                  height: vh(8);
                  margin: auto vw(10);
                }
                .text {
                  font-family: YouSheBiaoTiHei;
                  font-weight: 400;
                  font-size: vw(20);
                  background: linear-gradient(#ffffff 0%, #4caeff 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                }
              }
            }
          }
          .ele_trap_box {
            width: calc(100% - vw(350));
            height: 100%;
            .ele_trap_content {
              background: url("@/assets/other/baoxian_bg.png") no-repeat center;
              background-size: 100% 100%;
              width: 100%;
              height: vh(260);
            }
          }
        }
      }
      .right {
        width: vw(440);
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .wb_anay_box {
          width: 100%;
          height: calc((100% - vh(330)) / 2);
          .wb_anay_content {
            background: url("@/assets/image/g1.png") no-repeat center;
            background-size: 100% 100%;
            width: calc(100% - vw(30));
            height: calc(100% - vh(72));
            padding: vh(15);
          }
          .wb_charts {
            height: calc(100% - vh(40));
            margin-top: vh(10);
          }
        }

        .save_anay_box {
          height: vh(302);
          width: 100%;
          .save_content {
            background: url("@/assets/other/baoxian_bg.png") no-repeat center;
            background-size: 100% 100%;
            width: calc(100% - vw(30));
            height: calc(100% - vh(72));
            padding: vh(15);

            .label_list {
              width: vw(180);
              height: vh(30);
              font-weight: 400;
              font-size: vw(14);
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              background: url("@/assets/other/lab_bg.png") no-repeat center;
              background-size: 100% 100%;
              .icon {
                width: vw(22);
                height: vw(22);
                margin: 0 vw(10) 0 vw(20);
              }
            }
            .save_charts {
              height: calc(100% - vh(35));
              width: 100%;
            }
          }
        }
      }
    }
  }

  .large_bottom {
    background: url("@/assets/image/large_bottom_bg.png") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: vh(44);
  }
}

.item_box {
  display: flex;
  flex-direction: column;
  width: 100%;
  .item_title_box {
    width: calc(100% - vw(40));
    height: vh(36);
    background: url("@/assets/image/box_title_bg.png") no-repeat center;
    background-size: 100% 100%;
    margin-bottom: vh(6);
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    font-size: vw(24);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: vw(40);
    &.duan {
      background: url("@/assets/other/duan.png") no-repeat center;
      background-size: 100% 100%;
    }
    &.chang {
      background: url("@/assets/other/chang.png") no-repeat center;
      background-size: 100% 100%;
    }
    &.other {
      background: url("@/assets/image/center_title_bg.png") no-repeat center;
      background-size: 100% 100%;
    }
    .tags_box {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .tips_view {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: vw(14);
        color: #d6cfcd;
        font-family: Microsoft YaHei;
        .icon {
          width: vw(16);
          height: vw(16);
          margin-right: vw(6);
        }
        &.success {
          color: #34fa93;
        }
        &.warn {
          color: #fca30a;
        }
        &.danger {
          color: #ed4c33;
        }
        &.primary {
          color: #00eeff;
        }
      }
    }
  }
}

::v-deep .el-form-item {
  margin-bottom: 0 !important;

  .el-form-item__label {
    font-weight: 400;
    font-size: vw(14);
    color: #b8c6d3;
    line-height: vh(28);
  }
  .el-form-item__content {
    color: #09b5ff;
    line-height: vh(28);
    text-align: left;
  }
}
.device_label {
  height: vh(30);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .label_list {
    width: vw(180);
    height: 100%;
    font-weight: 400;
    font-size: vw(14);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: url("@/assets/other/lab_bg.png") no-repeat center;
    background-size: 100% 100%;
    .icon {
      width: vw(22);
      height: vw(22);
      margin: 0 vw(10) 0 vw(20);
    }
  }
}
::v-deep .el-table {
  thead {
    font-weight: 400;
    font-size: vw(16);
    color: #93e4ff;
    tr {
      background: rgba(27, 123, 214, 0.15);
    }
  }
  tr {
    background: rgba(0, 30, 58, 0.72);
    border: 1px solid rgba(103, 192, 255, 0.46);
  }
}
.tableSpec {
  width: 100%;
  --el-table-border-color: rgba(222, 253, 255, 0.16);
}
::deep(.el-table) {
  background-color: transparent;
}
::deep(.el-table__expanded-cell) {
  background-color: transparent;
}

::deep(.el-table th) {
  font-weight: 400;
  font-size: vw(14);
  color: #a3c8e8 !important;
  background-color: transparent !important;
  border-top: 1px solid #58bfff;
}
::v-deep .el-table::before {
  background-color: transparent !important;
}

::v-deep .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px dashed #093863 !important;
}
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #58bfff;
}
::v-deep .el-table .el-table__row .el-table__cell .cell {
  color: #fff;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: transparent !important;
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
</style>
